import Api from '../../../../services/api';
import React, { useEffect, useState } from 'react';
import { EOrgaoCodigo, EOrgaoDescricao } from '../../../../components/enums/orgao.enum'
import {
    message, Form,
    Switch, Card, Input, Spin,
    Button, Radio,
    InputNumber,
    AutoComplete
} from 'antd';
import MaskedTextInput from 'react-text-mask'
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../../../redux/actions/permissao';

import MaskedInput from 'react-input-mask'
import { copy_to_clipboard } from '../../../../utils/copy-to-clipboard';
import { IconCopyClipboard } from '../../../../components/IconCopyClipboard/IconCopy';
import { IResponseErrorEnderecoAPI, buscarEnderecoApi, validarCEP } from '../../../../utils/cept';
import { onKeyDownBloquearDigitosPorLength } from '../../../../utils/telefone';
import api from '../../../../services/api';

interface props {
    dados: any;
    permissao?: any
}

const DadosFuncionais: React.FC<props> = (props) => {
    const { Search } = Input;
    const history = useHistory()
    const [loading, setLoading] = useState(false);
    const { id } = useParams<Record<string, string | undefined>>();
    const [form] = Form.useForm();
    const [dadosFuncionaisID, setDadosFuncionaisID] = useState<number | undefined>();
    const [ctpsAssinada, setCtpsAssinada] = useState<boolean>(false);
    const [empregado, setEmpregado] = useState<boolean>(false);
    const [documentoID, setDocumentoID] = useState<number>();
    const [permissaoUserEditar, setPermissaoUserEditar] = useState<boolean>(false);
    const [mask1, setMask1] = useState("(99) 99999-9999");
    const [optionsInput, setOptionsInput] = useState<any[]>();
    let location = useLocation();
    var currentLocation = location.pathname
    let time: any;
    let option: any;
    var options: any[] = [];
    let paths = currentLocation.split('/');

    const orgao = [
        { id: EOrgaoCodigo.DPU, desc: EOrgaoDescricao.DPU },
        { id: EOrgaoCodigo.PF, desc: EOrgaoDescricao.PF },
        { id: EOrgaoCodigo.ReceitaFederal, desc: EOrgaoDescricao.ReceitaFederal },
        { id: EOrgaoCodigo.Funtrab, desc: EOrgaoDescricao.Funtrab },
        { id: EOrgaoCodigo.Sas, desc: EOrgaoDescricao.Sas },
        { id: EOrgaoCodigo.Cedami, desc: EOrgaoDescricao.Cedami },
        { id: EOrgaoCodigo.CentralMatriculas, desc: EOrgaoDescricao.CentralMatriculas },
        { id: EOrgaoCodigo.Cras, desc: EOrgaoDescricao.Cras },
        { id: EOrgaoCodigo.Funsat, desc: EOrgaoDescricao.Funsat },
    ]

    useEffect(() => {
        form.setFieldsValue({
            profissao: props.dados?.profissao,
            empresa: props.dados?.empresa,
            orgaoEmpresa: props.dados?.orgaoEmpresa,
            cargo: props.dados?.cargo,
            funcao: props.dados?.funcao,
            pis: props.dados?.pis,
            ctpsAssinada: props.dados?.ctpsAssinada ? props.dados?.ctpsAssinada : false,
            enderecoEmpresaRua: props.dados?.enderecoEmpresaRua,
            enderecoEmpresaBairro: props.dados?.enderecoEmpresaBairro,
            enderecoEmpresaComplemento: props.dados?.enderecoEmpresaComplemento,
            enderecoEmpresaCidade: props.dados?.enderecoEmpresaCidade,
            enderecoEmpresaNumero: props.dados?.enderecoEmpresaNumero,
            cepEmpresa: props.dados?.cepEmpresa,
            telefoneEmpresa: props.dados?.telefoneEmpresa,
            ocupacaoID: props.dados?.ocupacaoID
        });
        setDadosFuncionaisID(props.dados?.dadosFuncionaisID);
        setCtpsAssinada(props.dados?.ctpsAssinada ? props.dados?.ctpsAssinada : false)
        setEmpregado(props.dados?.empregado ? props.dados?.empregado : false)

        if (paths[4] == "agendamento" && props.permissao[0].permissaoAcesso?.editar == false) {

            setPermissaoUserEditar(true);

        } else {
            setPermissaoUserEditar(props.permissao[0].permissaoAcesso?.editar);
        }

    }, [props.dados])

    const submit = async (value: any) => {
        
        setLoading(true);
        if (empregado === false) {
            form.setFieldsValue({ empresa: null, orgaoEmpresa: null, cargo: null, funcao: null })
        }
        if (validacaoPISPASEP(value.pis)) {
            if (dadosFuncionaisID != null && dadosFuncionaisID != undefined) {
                await Api.put("DadosFuncionais", {
                    DadosFuncionaisID: dadosFuncionaisID,
                    Profissao: value.profissao,
                    Empregado: empregado,
                    CtpsAssinada: ctpsAssinada,
                    DadosCadastraisID: id ? parseInt(id) : 0,
                    Empresa: value.empresa,
                    OrgaoEmpresa: value.orgaoEmpresa,
                    Cargo: value.cargo,
                    Funcao: value.funcao,
                    EnderecoEmpresaRua: value.enderecoEmpresaRua,
                    EnderecoEmpresaBairro: value.enderecoEmpresaBairro,
                    EnderecoEmpresaComplemento: value.enderecoEmpresaComplemento,
                    EnderecoEmpresaCidade: value.enderecoEmpresaCidade,
                    EnderecoEmpresaNumero: value.enderecoEmpresaNumero,
                    CepEmpresa: value.cepEmpresa,
                    Pis: value.pis,
                    TelefoneEmpresa: value.telefoneEmpresa,
                    OcupacaoID: value.ocupacaoID
                })
                    .then((response) => {
                        message.success('Salvo com sucesso')
                    })
                    .catch((err) => {
                        message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                    })
                    .finally(() => {
                        setLoading(false);
                    })

            }
            else {
                await Api.post("DadosFuncionais", {
                    Profissao: value.profissao,
                    Empregado: empregado,
                    CtpsAssinada: ctpsAssinada,
                    DadosCadastraisID: id ? parseInt(id) : 0,
                    Empresa: value.empresa,
                    OrgaoEmpresa: value.orgaoEmpresa,
                    Cargo: value.cargo,
                    Funcao: value.funcao,
                    EnderecoEmpresaRua: value.enderecoEmpresaRua,
                    EnderecoEmpresaBairro: value.enderecoEmpresaBairro,
                    EnderecoEmpresaComplemento: value.enderecoEmpresaComplemento,
                    EnderecoEmpresaCidade: value.enderecoEmpresaCidade,
                    EnderecoEmpresaNumero: value.enderecoEmpresaNumero,
                    CepEmpresa: value.cepEmpresa,
                    Pis: value.pis,
                    TelefoneEmpresa: value.telefoneEmpresa,
                    OcupacaoID: value.ocupacaoID
                })
                    .then((response) => {
                        setDadosFuncionaisID(response?.data?.dadosFuncionais?.dadosFuncionaisID);
                        message.success('Salvo com sucesso')

                    })
                    .catch((err) => {
                        message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')

                    }).finally(() => {
                        setLoading(false);
                    })
            }
        }
    }
    const buscarEndereco = async (event: any) => {
        let target = event?.target
        let value = target?.value
        setLoading(true)
        await buscarEnderecoApi(value)
            .then((response) => {
                if (response) {
                    form.setFieldsValue({ enderecoEmpresaRua: response?.logradouro });
                    form.setFieldsValue({ enderecoEmpresaBairro: response?.bairro });
                    form.setFieldsValue({ enderecoEmpresaCidade: response?.localidade });
                }
            })
            .catch((e: IResponseErrorEnderecoAPI) => {
                if (e && e.mensagem) {
                    message.error(e.mensagem)
                }
                else {
                    message.error('Falha na requisição do CEP')
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const validacaoPISPASEP = (value: any) => {
        let pis = value;
        if (pis === undefined || pis === null || pis.length === 0) {
            setLoading(false)
            return true;
        }
        else if (pis != null && pis.length != 11) {
            message.error('Atenção: O PIS/PASEP precisa ter 11 dígitos.');
            setLoading(false)
            return false;
        }

        let x1 = Number(pis[0].toString()) * 3;
        let x2 = Number(pis[1].toString()) * 2;
        let x3 = Number(pis[2].toString()) * 9;
        let x4 = Number(pis[3].toString()) * 8;
        let x5 = Number(pis[4].toString()) * 7;
        let x6 = Number(pis[5].toString()) * 6;
        let x7 = Number(pis[6].toString()) * 5;
        let x8 = Number(pis[7].toString()) * 4;
        let x9 = Number(pis[8].toString()) * 3;
        let x10 = Number(pis[9].toString()) * 2;
        let D = Number(pis[10].toString());
        let S: number = (x1 + x2 + x3 + x4 + x5 + x6 + x7 + x8 + x9 + x10);
        let Resto = S % 11;
        let Sub = 11 - Resto;
        let Resultado = (Sub == 10 || Sub == 11) ? 0 : Sub;
        if (Resultado == D)
            return true;
        else {
            message.error('O PIS/PASEP informado é inválido.');
            setLoading(false)
            return false;
        }
    }

    const buscarMigrante = (e: any) => {
        clearTimeout(time);
        time = setTimeout(() => {
            api.get(`DadosFuncionais/buscarocupacaos?titulo=${e}`).then((response) => {
                configOptions(response.data)
            })

        }, 1000);
    }

    const onSelect = async (value: any, option: any) => {
        setLoading(true);
        form.setFieldsValue({ ocupacaoID: option.value })
        form.setFieldsValue({ profissao: option.label })
        setLoading(false)

    };

    const configOptions = (dados: any[]) => {
        dados.map((a: any) => {
            option = {
                value: a.ocupacaoID,
                label: a.titulo,
            }
            options.push(option)
        })
        setOptionsInput(options)
    }

    return (
        <>
            <div className="container">
                <div className="form-pesquisa">
                    <Spin spinning={loading}>

                        <Form
                            form={form}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                            onFinish={submit}
                        >
                            <div className="row">
                                <div className="site-card-border-less-wrapper col-md-12">
                                    <Card bordered={false} style={{ background: "#ececec" }}>
                                        <div className="row">
                                            <div className="col-md-6 ">
                                                <Form.Item
                                                    label="OcupacaoID"
                                                    name="ocupacaoID"
                                                    hidden={true}
                                                >
                                                    <Input type="number" hidden={true} />

                                                </Form.Item>
                                                <Form.Item name="profissao" label="Profissao" >
                                                    <AutoComplete
                                                        dropdownMatchSelectWidth={252}
                                                        options={optionsInput}
                                                        onSelect={onSelect}
                                                        onSearch={buscarMigrante}
                                                    >
                                                        <Input.Search size="middle" placeholder="Informe alguma profissão" enterButton disabled={permissaoUserEditar === false} />
                                                    </AutoComplete>
                                                    {/* <Input placeholder="Informe alguma profissão"
                                                        disabled={permissaoUserEditar === false}
                                                    /> */}
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-4">
                                                <Form.Item name="pis" label="PIS/PASEP">
                                                    <MaskedInput className="ant-input" placeholder="Informe PIS/PASEP" mask="99999999999"
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-2">
                                                <Form.Item name="ctpsAssinada" label="CTPS assinada?" >
                                                    <Radio.Group
                                                        disabled={permissaoUserEditar === false}
                                                        onChange={(e: any) => {
                                                            setCtpsAssinada(e.target.value)
                                                        }}>
                                                        <Radio.Button key="true" value={true}>
                                                            Sim
                                                        </Radio.Button>
                                                        <Radio.Button key="false" value={false}>
                                                            Não
                                                        </Radio.Button>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label></label>
                                                    <Form.Item name="empregado" label="" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                        Empregado
                                                        <Switch checked={empregado} onChange={() => { setEmpregado(!empregado); }}
                                                            disabled={permissaoUserEditar === false} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                                <br />
                                <div className="site-card-border-less-wrapper col-md-12 custom-opening">
                                    {!empregado ? null : <>
                                        <Card bordered={false} style={{ background: "#ececec" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Form.Item name="empresa" label="Empresa" >
                                                        <Input placeholder="Informe alguma empresa"
                                                            disabled={permissaoUserEditar === false}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* <div className="col-md-6">
                                                    <Form.Item name="orgaoEmpresa" label="Órgão" >
                                                        <Input placeholder="Informe algum órgão"
                                                            disabled={permissaoUserEditar === false}
                                                        />
                                                    </Form.Item>
                                                </div> */}
                                                <div className="col-md-6">
                                                    <Form.Item
                                                        label="Telefone Empresa"
                                                        name="telefoneEmpresa"
                                                    >
                                                        <MaskedInput placeholder="Informe algum telefone" onBlur={e => {
                                                            if (e.target.value.replace("_", "").length === 14) {
                                                                setMask1("(99) 9999-9999");
                                                            }
                                                        }}
                                                            onFocus={e => {
                                                                if (e.target.value.replace("_", "").length === 14) {
                                                                    setMask1("(99) 99999-9999");
                                                                }
                                                            }} className="ant-input" alwaysShowMask={false} mask={mask1} />
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Item name="funcao" label="Função" >
                                                        <Input placeholder="Informe alguma função"
                                                            disabled={permissaoUserEditar === false}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            {/* <div className="row">
                                                <div className="col-md-6">
                                                    <Form.Item name="cargo" label="Cargo" >
                                                        <Input placeholder="Informe algum cargo"
                                                            disabled={permissaoUserEditar === false}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                
                                            </div> */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <Form.Item name="cepEmpresa" label="CEP" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                                        rules={[
                                                            { required: true, message: 'Por favor, insira um CEP!', },
                                                            { validator: (_, value) => validarCEP(value), validateTrigger: 'onSubmit' }
                                                        ]}>
                                                        <MaskedTextInput
                                                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                                                            onKeyDown={(e: any) => { onKeyDownBloquearDigitosPorLength(e, 8) }}
                                                            placeholder="CEP" className={"globalInput cpfMaskedInput"} onBlur={(e) => buscarEndereco(e)}>
                                                        </MaskedTextInput>
                                                    </Form.Item>
                                                    <div style={{ position: 'absolute', right: 16, top: '41px' }}>
                                                        <span className="ant-input-group-addon" style={{ height: '30px' }}>
                                                            <span role="img" aria-label="copy" className="anticon anticon-copy">
                                                                <IconCopyClipboard copyToClipboard={() => { copy_to_clipboard(form.getFieldValue('cepEmpresa')) }} />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <Form.Item name="enderecoEmpresaCidade" label="Cidade"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor, insira uma cidade!',
                                                            }
                                                        ]}>
                                                        <Input placeholder="Informe uma cidade "
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-4">
                                                    <Form.Item name="enderecoEmpresaBairro" label="Bairro"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor, insira um bairro!',
                                                            }
                                                        ]}>
                                                        <Input placeholder="Informe um bairro"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-5">
                                                    <Form.Item name="enderecoEmpresaRua" label="Rua"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor, insira um logradouro!',
                                                            }
                                                        ]}>
                                                        <Input placeholder="informe um logradouro "

                                                        />
                                                    </Form.Item>
                                                </div>

                                                <div className="col-md-2">
                                                    <Form.Item name="enderecoEmpresaNumero" label="Número"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor, insira o número do endereço!',
                                                            }
                                                        ]}>
                                                        <InputNumber min={1} placeholder="informe o número do endereço" />

                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-5">
                                                    <Form.Item name="enderecoEmpresaComplemento" label="Complemento" >
                                                        <Input placeholder="informe o complemento"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Card>
                                    </>}

                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-1">
                                    <Form.Item className="align-items-end">
                                        {permissaoUserEditar === true ?
                                            <Button type="primary" htmlType="submit">Salvar</Button>
                                            : null}
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </Spin>
                    <br />

                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state: any) => ({
    permissao: state.permissao,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(PermissaoAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(DadosFuncionais);


